<template>
    <div
        class="container"
        @mouseenter="handleReportLx"
    >
        <mc-tooltip
            popper-class="same-supplier"
            theme="light"
            placement="top"
        >
            <template slot="content">
                <div class="same-supplier-tips">
                    <div>
                        该sku/城市存在同商报价风险，无法报价
                    </div>
                    <mc-link
                        href="/feedback.html"
                        text="我要反馈"
                    />
                </div>
            </template>
            <mc-input
                v-if="type === typeMap.input"
                :value="'同商禁止报价'"
                disabled
            >
                <div slot="suffix">
                    <i
                        class="mtdicon mtdicon-info-circle-o"
                    ></i>
                </div>
            </mc-input>
            <mc-tag
                v-else
                theme="red"
            >
                同商
                <i class="mtdicon mtdicon-question-circle-o"></i>
            </mc-tag>
        </mc-tooltip>
    </div>
</template>

<script>

import { reportLx } from '@lsfe/tools';
import { computed, onMounted } from '@vue/composition-api';
import { PRICE_REPORT_DETAIL_CID } from '../config';

const typeMap = {
    input: 'input',
    tag: 'tag',
};
export default {
    props: {
        type: {
            type: String,
            default: typeMap.input,
        },
        row: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props) {
        const lxParams = computed(() => {
            const {
                lxSupplierInfo = {}, skuId, skuName, cityId, cityName,
            } = props.row;
            return {
                ...lxSupplierInfo,
                sku_id: skuId,
                sku_name: skuName,
                city_id: cityId,
                city_name: cityName,
            };
        });
        const handleReportLx = () => {
            reportLx('moduleClick', 'b_chaoshi_tm6gyila_mc', lxParams.value, { cid: PRICE_REPORT_DETAIL_CID });
        };
        onMounted(() => {
            reportLx('moduleView', 'b_chaoshi_tm6gyila_mv', lxParams.value, { cid: PRICE_REPORT_DETAIL_CID });
        });
        return {
            typeMap,
            handleReportLx,
        };
    },
};
</script>

<style scoped lang="scss">
.container{
    margin-right:4px
}

/deep/ .mtd-input-wrapper{
    width: 130px;
}

/deep/ .mc-link span{
    font-size: 12px;
}

/deep/.mtd-btn.mtd-btn-text.mtd-btn-medium{
    padding-right: 0;
}

.same-supplier-tips{
    font-size: 12px;
    width: 278px;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
}

</style>
